import React from 'react';
import { Box, Button, Flex, Text, Icon, Link } from '@chakra-ui/react';
import { MdLock } from 'react-icons/md';
import { FeatureId, UPSELL_FEATURES } from 'src/constants/tier-features';
import { LOMA_BRAND_COLORS } from 'src/constants/ui';

interface FeatureUpgradeOverlayProps {
  children: React.ReactNode;
  featureId: FeatureId;
  isLocked?: boolean;
}

const FeatureUpgradeOverlay = ({
  children,
  featureId,
  isLocked = false,
}: FeatureUpgradeOverlayProps) => {
  if (!isLocked) {
    return <>{children}</>;
  }

  const feature = UPSELL_FEATURES[featureId];

  return (
    <Box position="relative" minH="400px">
      {/* Upgrade CTA overlay */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        zIndex={2}
        bg="white"
        borderRadius="xl"
        p={8}
        boxShadow="2xl"
        border="1px solid"
        borderColor="gray.200"
        maxW="400px"
        textAlign="center"
        mx="auto"
        my="auto"
      >
        <Flex direction="column" align="center" gap={4}>
          <Box
            bg="gray.100"
            borderRadius="full"
            p={4}
            color="gray.600"
            border="1px solid"
            borderColor="gray.200"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={MdLock} w={8} h={8} />
          </Box>

          <Box>
            <Text fontSize="lg" fontWeight="semibold" color="gray.800" mb={2}>
              {feature?.displayName || 'Premium Feature'}
            </Text>
            <Text fontSize="sm" color="gray.600" mb={4}>
              {feature?.description || 'Upgrade your plan to access this feature.'}
            </Text>
          </Box>

          <Button
            as={Link}
            colorScheme="blue"
            href={`mailto:contact@withloma.com?subject=Upgrade for ${encodeURIComponent(
              feature?.displayName || 'Premium Feature',
            )}`}
            rel="noopener noreferrer"
            target="_blank"
            size="md"
            bgGradient={`linear(135deg, ${LOMA_BRAND_COLORS.lightGreen}, ${LOMA_BRAND_COLORS.darkestLightGreen})`}
            _hover={{
              bgGradient: `linear(135deg, ${LOMA_BRAND_COLORS.darkerLightGreen}, ${LOMA_BRAND_COLORS.darkestLightGreen})`,
              transform: 'translateY(-1px)',
              boxShadow: 'md',
              textDecoration: 'none',
            }}
            _active={{
              transform: 'translateY(0)',
            }}
          >
            Upgrade Plan
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default FeatureUpgradeOverlay;
